<section class="relevant-article-section">
  <div class="container">
    <h2 class="section-title">More TechGeeks</h2>

    <div class="row g-4 justify-content-center">
      <!-- Loop through the 3 random TechGeek editions -->
      <div class="col-lg-4 col-md-6" *ngFor="let techgeek of relevantTechGeeks">
        
        <!-- The entire card is clickable and navigates to the correct route -->
        <div class="article-card" (click)="navigateTo(techgeek.route)">
          <img [src]="techgeek.image" [alt]="techgeek.title" class="card-image">
          <div class="card-content">
            <h5 class="card-title">{{ techgeek.title }}</h5>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>